import React, { useState, useEffect } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import BackgroundImage from '../../assets/footer.webp'
import Logo from '../../assets/logo_white.svg'
import { COLOR_BLACK, COLOR_WHITE, COLOR_GRAY__800 } from '../../lib/colors'
import {
  IconArrow,
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconYoutube,
} from '../../components/Icon/'
import { leToBr } from '../../utils/Utils'
import LayoutRow from '../../components/Layout/LayoutRow'
import LayoutCol from '../../components/Layout/LayoutCol'
import UILink from '../../components/UI/UILink'
import UIButton from '../../components/UI/UIButton'
import WidgetMotionDesign from '../../components/Widget/WidgetMotionDesign'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'
import { useForm, Controller } from 'react-hook-form'
import UIInput from '../../components/UI/UIInput'
import api from '../../api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Inter } from '../../lib/fonts'

const Footer = () => {
  let navigate = useNavigate()
  const { t } = useTranslation('translation')
  const [isMakerModalOpened, setMakerModalOpened] = useState(false)
  const [isViewerModalOpened, setViewerModalOpened] = useState(false)

  const {
    formState: { errors },
    control,
    trigger,
    reset,
    handleSubmit,
  } = useForm({ mode: 'all' })

  useEffect(() => {
    ;(async () => {
      await trigger('email')
    })()
  }, [])

  const onSubmit = async ({ email }) => {
    try {
      await toast.promise(api.subscripeNewsletter(email), {
        pending: t('pages.home.footer.pendingMessage'),
        success: t('pages.home.footer.successMessage'),
        error: t('pages.home.footer.errorMessage'),
      })
      reset()
    } catch (e) {
      toast.error(t('pages.home.footer.errorMessage'))
    }
  }

  return (
    <div className={css(styles.container)}>
      <img
        src={BackgroundImage}
        className={css(styles.backgroundImage)}
        alt="background image"
        width="100%"
        height="100%"
      />
      <div className={css(styles.containerContent)}>
        <div className={css(styles.panel, styles.leftPanel)}>
          <Link
            to="/"
            style={{ textAlign: window.innerWidth < 480 ? 'center' : 'unset' }}
          >
            <img
              src={Logo}
              className={css(styles.logo)}
              alt="logo"
              width="60%"
              height="auto"
            />
          </Link>
          {window.innerWidth < 480 ? (
            <LayoutCol col={6} dynamicStyle={styles.dynamicStyleLayoutCol}>
              <span className="footermaker">
                <p
                  className={css(styles.titleMobile)}
                  onClick={() => {
                    navigate('../be-a-maker')
                  }}
                >
                  <IconArrow
                    className="dynamicMobileIcon"
                    style={{
                      width: '0.85em',
                      height: '0.85em',
                    }}
                  />
                  {t('pages.home.footer.beAMaker')}
                </p>
              </span>
              <span className="footerviewer">
                <p
                  className={css(styles.titleMobile)}
                  onClick={() => {
                    navigate('../be-a-viewer')
                  }}
                >
                  <IconArrow
                    className="dynamicMobileIcon"
                    style={{
                      width: '0.85em',
                      height: '0.85em',
                    }}
                  />
                  {t('pages.home.footer.beAViewer')}
                </p>
              </span>
            </LayoutCol>
          ) : (
            <>
              <div className="dynamicDiv">
                <div className={css(styles.separator)} />
                <span className="footermaker">
                  <p
                    className={css(styles.title) + ' dynamicP'}
                    onClick={() => {
                      navigate('../be-a-maker')
                    }}
                  >
                    <IconArrow
                      className="dynamicIcon"
                      style={{
                        width: '0.80em',
                        height: '0.80em',
                        boxSizing: 'unset',
                        marginRight: '20px',
                      }}
                    />
                    {leToBr(t('pages.home.footer.beAMaker'))}
                  </p>
                </span>
              </div>
              <div className="dynamicDiv">
                <div className={css(styles.separator)} />
                <span className="footerviewer">
                  <p
                    className={css(styles.title) + ' dynamicP'}
                    onClick={() => {
                      navigate('../be-a-viewer')
                    }}
                  >
                    <IconArrow
                      className="dynamicIcon"
                      style={{
                        width: '0.80em',
                        height: '0.80em',
                        boxSizing: 'unset',
                        marginRight: '20px',
                      }}
                    />
                    {leToBr(t('pages.home.footer.beAViewer'))}
                  </p>
                </span>
              </div>
            </>
          )}
        </div>
        <div className={css(styles.panel, styles.rightPanel)}>
          {window.innerWidth < 480 ? (
            <div className={css(styles.separator, styles.override)} />
          ) : (
            <></>
          )}
          <p className={css(styles.subtitle)}>
            {t('pages.home.footer.ubiqeyes')}
          </p>
          <UILink
            linkTitle={t('pages.home.footer.legalMentionsLink')}
            redirection={'/mentions-legales.html'}
            alt={t('pages.home.footer.legalMentionsAlt')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.cguLink')}
            redirection={'/cgu.html'}
            alt={t('pages.home.footer.cguAlt')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.cgvLink')}
            redirection={'/cgv.html'}
            alt={t('pages.home.footer.cgvAlt')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.kindnessChartersLink')}
            redirection={'/charte-de-bienveillance.html'}
            alt={t('pages.home.footer.kindnessChartersLink')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.privacyPolicyLink')}
            redirection={'/politique-de-confidentialite.html'}
            alt={t('pages.home.footer.privacyPolicyLink')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.cookieManagementLink')}
            redirection={'/politique-de-cookies.html'}
            alt={t('pages.home.footer.cookieManagementLink')}
          ></UILink>
          <p className={css(styles.subtitle)}>
            {t('pages.home.footer.become')}
          </p>
          <UIButton
            label={t('pages.home.footer.whatIsAMaker')}
            kind="text"
            design="simpleText"
            onClick={() => setMakerModalOpened(true)}
            textStyle={styles.modalLink}
            dynamicStyle={styles.btnLink}
          ></UIButton>
          <UIButton
            label={t('pages.home.footer.whatIsAViewer')}
            kind="text"
            design="simpleText"
            onClick={() => setViewerModalOpened(true)}
            textStyle={styles.modalLink}
            dynamicStyle={styles.btnLink}
          ></UIButton>
          <WidgetMotionDesign
            isModalOpened={isMakerModalOpened}
            setModalOpened={setMakerModalOpened}
            video={'/assets/maker.mp4'}
          ></WidgetMotionDesign>
          <WidgetMotionDesign
            isModalOpened={isViewerModalOpened}
            setModalOpened={setViewerModalOpened}
            video={'/assets/viewer.mp4'}
          ></WidgetMotionDesign>

          <p className={css(styles.subtitle)}>{t('pages.home.footer.about')}</p>
          <UILink
            linkTitle={t('pages.home.footer.moreInformations')}
            redirection={'/a-propos.html'}
            alt={t('pages.home.footer.moreInformations')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.ourOffers')}
            target="_self"
            redirection={'/be-a-viewer'}
            alt={t('pages.home.footer.ourOffers')}
          ></UILink>
          <p className={css(styles.subtitle)}>
            {t('pages.home.footer.contactUs')}
          </p>
          <UILink
            linkTitle={t('pages.home.footer.needInfos')}
            target="_self"
            redirection={'mailto:serviceclient@ubiqeyes.com'}
            alt={t('pages.home.footer.needInfosAlt')}
          ></UILink>
          <UILink
            linkTitle={t('pages.home.footer.aProblem')}
            target="_self"
            redirection={'mailto:reclamation@ubiqeyes.com'}
            alt={t('pages.home.footer.aProblemAlt')}
          ></UILink>
          <div className={css(styles.separator)} />
          <p className={css(styles.contact)}>
            <a
              href="tel:+33972631131"
              style={{ color: 'white', textDecoration: 'none' }}
            >
              {t('pages.home.footer.phoneNumberUbiqeye')}
            </a>
          </p>
          <div className={css(styles.separator)} />

          <div className={css(styles.socialMedia)}>
            <UILink
              socialIcon={<IconFacebook dynamicStyle={styles.icon} />}
              redirection={
                'https://www.facebook.com/profile.php?id=100085535453086'
              }
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconYoutube dynamicStyle={styles.icon} />}
              redirection={'https://www.youtube.com/@ubiqeyes'}
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconLinkedin dynamicStyle={styles.icon} />}
              redirection={'https://fr.linkedin.com/company/ubiqeyes'}
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconInstagram dynamicStyle={styles.icon} />}
              redirection={'https://www.instagram.com/ubiqeyes/'}
              linkStyle="socialMedia"
            />
          </div>

          <p className={css(styles.subscribe)}>
            {t('pages.home.footer.subscribeNewletter')}
          </p>
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <LayoutRow gutter="large">
                <LayoutCol col={8}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => <UIInput {...field} />}
                    rules={{
                      required: {
                        value: true,
                        message: t('common.form.errorMessage.emailEmptyError'),
                      },
                      pattern: {
                        value:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: t(
                          'common.form.errorMessage.invalidEmailEmptyError'
                        ),
                      },
                    }}
                  />
                </LayoutCol>
                <LayoutCol col={4}>
                  <input
                    id="newsletter"
                    type="submit"
                    className={css(
                      styles.button,
                      errors.email && styles.disabledButton
                    )}
                    value={t('common.button.send')}
                    disabled={errors.email}
                  />
                </LayoutCol>
              </LayoutRow>
            </form>
          </div>
          <div className={css(styles.separator)} />
        </div>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    '@media (max-width: 480px)': {
      position: 'relative',
      height: 'auto',
    },
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    zIndex: '-1',
    width: '100%',
    '@media (max-width: 1200px)': {
      position: 'absolute',
      top: '0',
      left: '0',
      height: '100%',
    },
    '@media (max-width: 480px)': {
      position: 'absolute',
      top: '0',
      height: '100%',
    },
  },
  logo: {
    width: '60%',
  },
  containerContent: {
    position: 'relative',
    padding: '6em 1em 6em 6em',
    zIndex: 2,
    display: 'flex',
    width: '100%',
    height: '100%',
    '@media (max-width: 1200px)': {
      position: 'relative',
      padding: '2em 2em 6em 6em',
    },
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      padding: '0',
      paddingTop: '10%',
      paddingLeft: '5%',
      paddingRight: '5%',
      position: 'relative',
      top: '0',
      height: 'auto',
    },
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    height: 'auto',
    padding: '0em 7em 0em 0em',
    color: COLOR_WHITE,
  },
  leftPanel: {
    '@media (max-width: 480px)': {
      width: '100%',
      padding: '0px',
      justifyContent: 'flex-end',
      flexDirection: 'column',
    },
  },
  rightPanel: {
    padding: '1em 0em',
    '@media (max-width: 480px)': {
      padding: '0px',
    },
  },
  separator: {
    width: '100%',
    minHeight: '0.4em',
    backgroundColor: COLOR_WHITE,
    margin: '0 0 1em 0',
  },
  smallSeparator: {
    '@media (max-width: 480px)': {
      margin: '10px 0 10px 0',
    },
  },
  override: {
    '@media (max-width: 480px)': {
      marginBottom: '0px',
    },
  },
  dynamicStyleLayoutCol: {
    maxWidth: 'unset',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.4em',
  },
  titleMobile: {
    margin: 0,
    fontFamily: [Inter, 'sans-serif'],
    fontStyle: 'normal',
    fontWeight: '600',
    letterSpacing: '-0.05em',
    lineHeight: '1.3em',
    fontSize: '5vw',
    whiteSpace: 'nowrap',
    color: '#E26B76',
    backgroundColor: 'white',
    padding: '0.35em 1.20em',
    borderRadius: '8vmax',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  title: {
    fontWeight: 800,
    letterSpacing: '-0.05em',
    lineHeight: '.9em',
    fontSize: '6em',
    padding: '0px',
    margin: '0 0 0 25px',
    cursor: 'pointer',
    '@media (max-width: 480px)': {
      fontWeight: 600,
      letterSpacing: '-0.05em',
      lineHeight: '26pm',
      fontSize: '26px',
      whiteSpace: 'nowrap',
    },
  },
  subtitle: {
    color: COLOR_WHITE,
    fontWeight: 700,
    letterSpacing: '-0.05em',
    fontSize: '1em',
    padding: '1em 0em 0em 0em',
    margin: 0,
  },
  details: {
    fontWeight: 200,
    letterSpacing: '-0.05em',
    fontSize: '1em',
    padding: 0,
    margin: 0,
  },
  contact: {
    fontWeight: 700,
    fontSize: '2em',
    letterSpacing: '-0.05em',
    padding: 0,
    margin: 0,
    '@media (max-width: 480px)': {
      fontWeight: 600,
      letterSpacing: '-0.05em',
      lineHeight: '26pm',
      fontSize: '14px',
    },
  },
  socialMedia: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  },
  iconButton: {
    padding: 0,
    margin: '0.5em 0.5em',
  },
  subscribe: {
    fontWeight: 700,
    fontSize: '1.5em',
    letterSpacing: '-0.05em',
    padding: 0,
    margin: '0.6em 0em 0em 0em',
    '@media (max-width: 480px)': {
      fontWeight: 200,
      letterSpacing: '-0.05em',
      lineHeight: '1pm',
      fontSize: '1em',
      whiteSpace: 'nowrap',
    },
  },
  input: {
    border: 'none',
    width: '25%',
    height: '2em',
    marginTop: '0.5em',
    '@media (max-width: 480px)': {
      width: '60%',
    },
  },
  button: {
    backgroundColor: COLOR_BLACK,
    color: COLOR_WHITE,
    padding: '1em 1.5em',
    marginLeft: '0.6em',
    letterSpacing: '-0.05em',
    fontWeight: 700,
    cursor: 'pointer',
  },
  disabledButton: {
    backgroundColor: COLOR_GRAY__800,
  },
  icon: {
    width: 35,
  },
  modalLink: {
    color: COLOR_WHITE,
    [MEDIA_MIN_SM]: {
      fontSize: 12,
    },
    ':hover': {
      textDecorationLine: 'underline',
    },
  },
  btnLink: {
    textAlign: 'start',
    padding: 0,
  },
})

export default Footer
